// extracted by mini-css-extract-plugin
module.exports = {"gallery-image":"GalleryImageList_gallery-image__ya7C4"};